var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaggzOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 26,
    viewBox: "0 0 49 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.642638 5.4138C0.341684 4.7517 0.825715 4 1.553 4H49V24C49 25.1046 48.1046 26 47 26H1.55301C0.825717 26 0.341683 25.2483 0.642638 24.5862L4.81191 15.4138C4.93142 15.1509 4.93142 14.8491 4.81191 14.5862L0.642638 5.4138Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.642638 5.4138C0.341684 4.7517 0.825715 4 1.553 4H49V24C49 25.1046 48.1046 26 47 26H1.55301C0.825717 26 0.341683 25.2483 0.642638 24.5862L4.81191 15.4138C4.93142 15.1509 4.93142 14.8491 4.81191 14.5862L0.642638 5.4138Z",
    fill: "url(#paint0_linear_1_5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 0L49 4H46V0Z",
    fill: "#CC5A03"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5",
    x1: -7.5,
    y1: 29.5,
    x2: 50.3617,
    y2: 4.84906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8172F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7B03"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaggzOrange);
export default __webpack_public_path__ + "static/media/taggzOrange.2d403f4e325bb32742421ca27bd465a1.svg";
export { ForwardRef as ReactComponent };